import { Component } from '@theme/component';

/** Reuse native cart/variant updates while supporting required line-item properties. */
class CustomStickyCart extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.section = this.closest('.shopify-section');
    this.bar = this.querySelector('.sticky-add-to-cart__bar');
    if (!this.section || !this.bar) return;
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.schedule = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
    };
    window.addEventListener('scroll', this.schedule, { ...options, passive: true });
    this.closest('.page-wrapper')?.addEventListener('scroll', this.schedule, { ...options, passive: true });
    window.addEventListener('resize', this.schedule, options);
    document.addEventListener('toggle', this.schedule, { ...options, capture: true });
    this.chatObserver = new MutationObserver(this.schedule);
    const chat = document.querySelector('shopify-chat');
    if (chat) this.chatObserver.observe(chat, { attributes: true, attributeFilter: ['open'] });
    this.resizeObserver = new ResizeObserver(this.schedule);
    this.resizeObserver.observe(this.section);
    this.setAttribute('data-ready', '');
    this.update();
  }

  update() {
    const buyButtons = this.section.querySelector('.buy-buttons-block');
    const footer = document.querySelector('footer');
    if (!buyButtons) { this.bar.dataset.customVisible = 'false'; return; }
    const passedButtons = buyButtons.getBoundingClientRect().bottom <= 0;
    const nearFooter = footer && footer.getBoundingClientRect().top < window.innerHeight + 200;
    const overlayOpen = document.querySelector('dialog[open], shopify-chat[open]');
    this.bar.dataset.customVisible = String(passedButtons && !nearFooter && !overlayOpen);
  }

  submit(event) {
    event.preventDefault();
    const form = this.section.querySelector('product-form-component form');
    if (!form) return;
    if (!form.checkValidity()) {
      const invalid = [...form.elements].find((input) => input.willValidate && !input.validity.valid);
      if (invalid) {
        const target = invalid.closest('.product-ring-size') || invalid;
        // Settle scrolling before native validation positions its message.
        target.scrollIntoView({ behavior: 'instant', block: 'center' });
        invalid.focus({ preventScroll: true });
      }
      form.reportValidity();
      return;
    }
    this.querySelector('sticky-add-to-cart')?.handleAddToCartClick();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.controller?.abort();
    this.chatObserver?.disconnect();
    this.resizeObserver?.disconnect();
    if (this.frame) cancelAnimationFrame(this.frame);
  }
}
if (!customElements.get('custom-sticky-cart-component')) customElements.define('custom-sticky-cart-component', CustomStickyCart);
